import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fc0f90e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "customer-service" }
const _hoisted_4 = {
  key: 0,
  class: "qrcode-dialog"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "qrocde",
  src: "//res-cn.public.gblinker.com/gblinker/wechat_mini/images/7e512874b296efc95d5e0e998538d47c.jpg"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "微信扫码，立即联系客服", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "wave-content" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"wave-wrapper\" data-v-6fc0f90e><div class=\"wave-content wave-a\" data-v-6fc0f90e></div></div><div class=\"wave-wrapper\" data-v-6fc0f90e><div class=\"wave-content wave-b\" data-v-6fc0f90e></div></div><div class=\"wave-wrapper\" data-v-6fc0f90e><div class=\"wave-content\" data-v-6fc0f90e><img src=\"//res-cn.public.gblinker.com/gblinker/wechat_mini/images/wechat.141b632259498b3d64010e695ca3b556.jpg\" alt=\"微信咨询\" data-v-6fc0f90e></div></div>", 3)
const _hoisted_12 = [
  _hoisted_9
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "客服咨询", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeBanner = _resolveComponent("HomeBanner")!
  const _component_HomeAddress = _resolveComponent("HomeAddress")!
  const _component_HomeTransition = _resolveComponent("HomeTransition")!
  const _component_HomeMore = _resolveComponent("HomeMore")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HomeBanner),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_HomeAddress),
      _createVNode(_component_HomeTransition),
      _createVNode(_component_HomeMore),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.showQrcodeDialog)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "wave",
            id: "open-customer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCustomerServices && _ctx.handleCustomerServices(...args)))
          }, _hoisted_12),
          _hoisted_13
        ])
      ])
    ])
  ]))
}